
import React from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import FormDivider from "../common/FormDivider";
import SocialLoginButtons from "../common/SocialLoginButtons";

export const RegistrationSocialLogin = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const redirectTo = searchParams.get('redirectTo');

  const handleSocialLogin = async (provider: "google" | "facebook") => {
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider,
        options: {
          redirectTo: `${window.location.origin}${redirectTo ? `/waitlist` : '/dashboard'}`,
        },
      });

      if (error) {
        toast.error(`Failed to sign in with ${provider}: ${error.message}`);
      }
    } catch (error) {
      console.error(`${provider} login error:`, error);
      toast.error(`Failed to sign in with ${provider}`);
    }
  };

  return (
    <>
      <FormDivider text="or sign up with" className="my-4" />
      <SocialLoginButtons 
        onGoogleClick={() => handleSocialLogin("google")}
        onFacebookClick={() => handleSocialLogin("facebook")}
      />
    </>
  );
};

